import { render, staticRenderFns } from "./Spreader.vue?vue&type=template&id=5afb9606&"
import script from "./Spreader.vue?vue&type=script&lang=js&"
export * from "./Spreader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports